import { render, staticRenderFns } from "./ContactsMembershipForm.vue?vue&type=template&id=48c5bd92&"
import script from "./ContactsMembershipForm.vue?vue&type=script&lang=js&"
export * from "./ContactsMembershipForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports